import { supabase, handleSupabaseError } from '@/integrations/supabase/client';

export type FormSubmissionMetadata = Record<string, string | number | boolean | null>;

export interface FormSubmissionPayload {
  formType: string;
  email: string;
  phone?: string;
  message?: string;
  userId?: string | null;
  metadata?: FormSubmissionMetadata;
}


export interface FormSubmissionResult<T = unknown> {
  data: T | null;
  error: string | null;
}

export const logFormSubmission = async (payload: FormSubmissionPayload): Promise<FormSubmissionResult> => {
  try {
    const insertPayload: Record<string, unknown> = {
      form_type: payload.formType,
      email: payload.email,
      phone: payload.phone ?? null,
      message: payload.message ?? null,
      metadata: payload.metadata ?? null,
    };

    if (payload.userId) {
      insertPayload.user_id = payload.userId;
    }

    const { data, error } = await supabase
      .from('form_submissions')
      .insert(insertPayload)
      .select()
      .single();

    if (error) {
      return { data: null, error: handleSupabaseError(error) };
    }

    return { data, error: null };
  } catch (err) {
    return { data: null, error: handleSupabaseError(err) };
  }
};

